import { getKeyValue } from '@heroui/react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from '@atoms/new/dropdown';
import { TrashIcon as Trash, CaretDownIcon as CaretDown } from '@phosphor-icons/react';
import Button from '@atoms/new/button';

interface CellDataProps {
  columnKey: any;
  item: any;
  deleteItem: (id: string) => void;
  isOwner?: boolean;
}
export default function CellData({
  columnKey,
  item,
  deleteItem,
  isOwner
}: CellDataProps) {
  if (getKeyValue(item, columnKey) === 'Pending') {
    return <Button
      size='sm'
      onClick={() => deleteItem(item.key)}
      kind='secondary'
      isDisabled={!isOwner}
    >Revoke</Button>;
  }

  if (columnKey !== 'role' || item.role === 'Admin' || (!isOwner && columnKey === 'role')) { return getKeyValue(item, columnKey); }

  return <Dropdown>
    <DropdownTrigger>
      <Button kind='tertiary'>
        {getKeyValue(item, columnKey)}
        <CaretDown size={16} />
      </Button>
    </DropdownTrigger>
    <DropdownMenu aria-label="Dynamic Actions">
      <DropdownItem
        // color={item.key === "delete" ? "danger" : "default"}
        // className={item.key === "delete" ? "text-danger" : ""}
        onAction={() => deleteItem(item.key)}
      >
        <div className='text-pure-red-600 flex gap-2 text-sm items-center'>
          <Trash size={16} />
          Remove from workspace
        </div>
      </DropdownItem>
    </DropdownMenu>
  </Dropdown>;
}
